import theme from '../theme/theme';

const {
  colors: { normal_traffic, heavy_traffic, distance_traveled },
} = theme;

const trafficColor = trafficCondition => {
  switch (trafficCondition) {
    case 'normal':
      return normal_traffic;
    case 'light':
      return normal_traffic;
    case 'heavy':
      return heavy_traffic;
    case 'closed':
      return normal_traffic;
    case 'currentDistance':
      return distance_traveled;
    default:
      return normal_traffic;
  }
};

export default {
  trafficColor,
};
